import * as React from 'react';

import { LocalizedComponentProps } from 'bernie-l10n';

import { useLocalization } from '@shared-ui/localization-context';

import { UitkExpandoPeek, UitkExpandoPeekProps } from 'uitk-react-expando';

export type LocalizedToggleProps = LocalizedComponentProps & UitkExpandoPeekProps;

export const LocalizedToggle: React.FunctionComponent<LocalizedToggleProps> = props => {
  const l10n = useLocalization();

  return (
    <UitkExpandoPeek
      expandLabel={l10n.formatText('contentToggle.expand.label')}
      collapseLabel={l10n.formatText('contentToggle.collapse.label')}
      {...props}
      collapseHeight={200}
    />
  );
};
LocalizedToggle.displayName = 'LocalizedToggle';
